var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMultiChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M26 7.277L24.308 5.6l-3.42 3.807A12.981 12.981 0 0 0 11.132 5 13.84 13.84 0 0 0 2 8.558l1.7 1.684a11.34 11.34 0 0 1 7.428-2.87 10.594 10.594 0 0 1 8.124 3.843L15.8 15.058 11 10.314l-9 8.907L3.8 21l7.2-7.128 4.8 4.744 4.86-5.4a14.435 14.435 0 0 1 1.728 5.4H24.8a16.643 16.643 0 0 0-2.448-7.282z",
    transform: "translate(-2 -5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultiChart);
export default __webpack_public_path__ + "static/media/icon-multi-chart.8bb31bbb.svg";
export { ForwardRef as ReactComponent };